import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import { PostFlightVisibilityAudit } from '../../+models/aircraft-profile-audit.model';

@Component({
  selector: 'sd-portal-postflight-visibility-audit-list',
  templateUrl: './postflight-visibility-audit-list.component.html',
  styleUrls: ['./postflight-visibility-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostFlightVisibilityAuditListComponent implements OnInit {
  @Input() postFlightVisibilityId: number;
  @Input() loading: boolean;
  @Input() postFlightVisibilityAudits: PostFlightVisibilityAudit[];

  @Output() loadPostFlightVisibility = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadPostFlightVisibility.emit(this.postFlightVisibilityId);
  }

  onNextPage() {
    this.nextPage.emit(this.postFlightVisibilityId);
  }
}
